import * as R from 'ramda'

declare var ORDERS_SVC_API5: string
declare var ORDERS_V6_ENABLED: boolean

interface Condition {
  field: string
}

const TimeFields = ['time', 'order_at', 'created_at', 'updated_at', 'placed_at']

export const hasTimeCondition = (conditions: Condition[]) =>
  R.any(({ field }) => TimeFields.includes(field), conditions)

const allFieldsAreSupportedByV6 = (conditions: Condition[]) =>
  R.all(
    ({ field }) =>
      [
        ...TimeFields,
        'state',
        'restaurant_name',
        'restaurant_id',
        'ivr_code',
        'service_id',
        'channel_id',
        'channel_name',
      ].includes(field),
    conditions
  )

export const getSearchAPI = (operator: string, conditions: Condition[]) =>
  // ORDERS_V6_ENABLED && operator == 'AND' && hasTimeCondition(conditions) && allFieldsAreSupportedByV6(conditions) ? ORDERS_SVC_API5 + '/v6/search' : ORDERS_SVC_API5 + '/v5/search'  
  `${ORDERS_SVC_API5}/v6/search`

export const getSearchAPIVersion = (operator: 'AND' | 'OR', conditions: Condition[]) =>
  // ORDERS_V6_ENABLED && operator == 'AND' && hasTimeCondition(conditions) && allFieldsAreSupportedByV6(conditions) ? 'v6' : 'v5'
  'v6'